import axios from 'axios';

let cancel;

// https://staging1.apptitude.xyz

const baseURL =
  process.env.NODE_ENV === 'production'
    ? 'https://apptitude.xyz/api/v1/website/'
    : 'https://apptitude.xyz/api/v1/website/';

const axiosInstance = axios.create({
  // api/v1/website
  baseURL,
  cancelToken: new axios.CancelToken(function executor(c) {
    cancel = response => {
      c({ response, status: 999 });
    };
  }),
  // headers: { 'Access-Control-Allow-Origin': '*' },
});

const requestInterceptor = async origConfig => {
  let config = origConfig;
  // const token = window.sessionStorage.getItem('token')
  if (window.sessionStorage.getItem('token')) {
    // token is not yet required in requests
    // config.headers.Authorization = `Bearer ${token}`
  }

  return config;
};

axiosInstance.interceptors.request.use(requestInterceptor);

axiosInstance.cancel = cancel;

export default axiosInstance;
